/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmailUpdateBody
 */
export interface EmailUpdateBody {
    /**
     * 
     * @type {string}
     * @memberof EmailUpdateBody
     */
    verificationCode: string;
}

/**
 * Check if a given object implements the EmailUpdateBody interface.
 */
export function instanceOfEmailUpdateBody(value: object): value is EmailUpdateBody {
    if (!('verificationCode' in value) || value['verificationCode'] === undefined) return false;
    return true;
}

export function EmailUpdateBodyFromJSON(json: any): EmailUpdateBody {
    return EmailUpdateBodyFromJSONTyped(json, false);
}

export function EmailUpdateBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmailUpdateBody {
    if (json == null) {
        return json;
    }
    return {
        
        'verificationCode': json['verificationCode'],
    };
}

export function EmailUpdateBodyToJSON(json: any): EmailUpdateBody {
    return EmailUpdateBodyToJSONTyped(json, false);
}

export function EmailUpdateBodyToJSONTyped(value?: EmailUpdateBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'verificationCode': value['verificationCode'],
    };
}

